import {Modal} from 'react-bootstrap'
import {ApiGoogle} from '../../../../../../infra/http/google-api'
import {getComercios} from '../../../../../../services/service/comercios'
import {mapStore} from '../../../../../../store/mapStore'
import {Button} from '../../../../../components/UI/Buttons.tsx/Button'
import {useEffect, useMemo, useState} from 'react'
import {Explorer} from '../Explorer'
import {Layout} from '../Layout'

type PropsComercios = {
  lat: number
  lng: number
}
const LoadComercios = ({lat, lng}: PropsComercios) => {
  const [show, setShow] = useState(false)
  const defaultChecked = ['bakery']
  const onlyTypes = []
  const hideCategories = []
  const hideItens = [
    'farm',
    'ranch',
    'arena',
    'athletic_field',
    'fishing_charter',
    'fishing_pond',
    'fitness_center',
    'golf_course',
    'ice_skating_rink',
    'playground',
    'ski_resort',
    'sports_activity_location',
    'sports_club',
    'sports_coaching',
    'sports_complex',
    'stadium',
    'sandwich_shop',
    'seafood_restaurant',
    'spanish_restaurant',
    'steak_house',
    'sushi_restaurant',
    'tea_house',
    'thai_restaurant',
    'turkish_restaurant',
    'vegan_restaurant',
    'vegetarian_restaurant',
    'vietnamese_restaurant',
    'wine_bar',
    'french_restaurant',
    'greek_restaurant',
    'hamburger_restaurant',
    'ice_cream_shop',
    'indian_restaurant',
    'indonesian_restaurant',
    'italian_restaurant',
    'japanese_restaurant',
    'juice_shop',
    'korean_restaurant',
    'lebanese_restaurant',
    'meal_delivery',
    'meal_takeaway',
    'mediterranean_restaurant',
    'mexican_restaurant',
    'middle_eastern_restaurant',
    'pizza_restaurant',
    'pub',
    'ramen_restaurant',
    'dessert_restaurant',
    'dessert_shop',
    'diner',
    'dog_cafe',
    'donut_shop',
    'fast_food_restaurant',
    'candy_store',
    'cat_cafe',
    'chinese_restaurant',
    'chocolate_factory',
    'chocolate_shop',
    'coffee_shop',
    'confectionery',
    'bar',
    'bar_and_grill',
    'barbecue_restaurant',
    'brazilian_restaurant',
    'brunch_restaurant',
    'buffet_restaurant',
    'breakfast_restaurant',
    'acai_shop',
    'afghani_restaurant',
    'african_restaurant',
    'american_restaurant',
    'asian_restaurant',
    'bagel_shop',
    'transit_depot',
    'transit_station',
    'truck_stop',
    'taxi_stand',
    'park_and_ride',
    'ferry_terminal',
    'heliport',
    'international_airport',
    'airport',
    'airstrip',
    'adventure_sports_center',
    'amphitheatre',
    'amusement_center',
    'amusement_park',
    'aquarium',
    'banquet_hall',
    'barbecue_area',
    'botanical_garden',
    'bowling_alley',
    'casino',
    'childrens_camp',
    'comedy_club',
    'community_center',
    'concert_hall',
    'convention_center',
    'cultural_center',
    'cycling_park',
    'dance_hall',
    'dog_park',
    'event_venue',
    'ferris_wheel',
    'garden',
    'hiking_area',
    'historical_landmark',
    'internet_cafe',
    'karaoke',
    'marina',
    'movie_rental',
    'movie_theater',
    'national_park',
    'night_club',
    'observation_deck',
    'off_roading_area',
    'opera_house',
    'park',
    'philharmonic_hall',
    'picnic_ground',
    'planetarium',
    'plaza',
    'roller_coaster',
    'skateboard_park',
    'state_park',
    'tourist_attraction',
    'video_arcade',
    'visitor_center',
    'water_park',
    'wedding_venue',
    'wildlife_park',
    'wildlife_refuge',
    'zoo',
    'inn',
    'japanese_inn',
    'lodging',
    'mobile_home_park',
    'motel',
    'private_guest_room',
    'resort_hotel',
    'rv_park',
    'bed_and_breakfast',
    'budget_japanese_inn',
    'campground',
    'camping_cabin',
    'cottage',
    'extended_stay_hotel',
    'farmstay',
    'guest_house',
    'hostel',
    'apartment_building',
    'apartment_complex',
    'condominium_complex',
    'housing_complex',
    'tanning_studio',
    'physiotherapist',
    'sauna',
    'skin_care_clinic',
    'massage',
    'medical_lab',

    'chiropractor',
    'dental_clinic',
    'dentist',
    'doctor',
    'drugstore',
    'sculpture',
    'cultural_landmark',
    'historical_place',
    'monument',
    'art_gallery',
    'art_studio',
    'city_hall',
    'courthouse',
    'embassy',
    'fire_station',
    'government_office',
    'local_government_office',
    'police',
    'post_office',
    'roofing_contractor',
    'storage',
    'summer_camp_organizer',
    'tailor',
    'telecommunications_service_provider',
    'tour_agency',
    'tourist_information_center',
    'travel_agency',
    'lawyer',
    'locksmith',
    'makeup_artist',
    'moving_company',
    'nail_salon',
    'painter',
    'plumber',
    'psychic',
    'insurance_agency',
    'body_art_service',
    'catering_service',
    'cemetery',
    'child_care_agency',
    'consultant',
    'courier_service',
    'electrician',
    'florist',
    'food_delivery',
    'foot_care',
    'funeral_home',
    'astrologer',
    'sporting_goods_store',
    'shoe_store',
    'butcher_shop',
    'cell_phone_store',
    'clothing_store',
    'convenience_store',
    'department_store',
    'discount_store',
    'electronics_store',
    'food_store',
    'furniture_store',
    'gift_shop',
    'grocery_store',
    'hardware_store',
    'home_goods_store',
    'home_improvement_store',
    'jewelry_store',
    'liquor_store',
    'asian_grocery_store',
    'auto_parts_store',
    'bicycle_store',
    'rest_stop',
    'car_rental',
    'car_repair',
    'car_wash',
  ]
  const columns = 5
  const labelOverrides = {
    bakery: 'Padaria',
    post_office: 'Correios',
    school: 'Escola',
    primary_school: 'Escola primária',
    secondary_school: 'Escola secundária',
    university: 'Universidade',
    hotel: 'Hotel',
    lodging: 'Hospedagem',
    shopping_mall: 'Shopping',
    hardware_store: 'Loja de ferragens',
    butcher_shop: 'Açougue',
    liquor_store: 'Loja de bebidas',
    hair_salon: 'Cabeleireiro',
    beauty_salon: 'Salão de beleza',
    gym: 'Academia',
    dentist: 'Dentista',
    library: 'Biblioteca',
    police_station: 'Delegacia de polícia',
    embassy: 'Embaixada',
    courthouse: 'Tribunal',
    city_hall: 'Prefeitura',
    fire_station: 'Corpo de Bombeiros',
    airport: 'Aeroporto',
    bus_station: 'Rodoviária',
    train_station: 'Estação de trem',
    subway_station: 'Estação de metrô',
    church: 'Igreja',
    mosque: 'Mesquita',
    synagogue: 'Sinagoga',
    hindu_temple: 'Templo hindu',
    museum: 'Museu',
    park: 'Parque',
    zoo: 'Zoológico',
    aquarium: 'Aquário',
    stadium: 'Estádio',
    movie_theater: 'Cinema',
    night_club: 'Casa noturna',
    spa: 'Spa',
    lawyer: 'Advogado',
    doctor: 'Médico',
    pharmacy_store: 'Drogaria',
    real_estate_agency: 'Imobiliária',
    travel_agency: 'Agência de viagens',
    veterinary_care: 'Veterinário',
    florist: 'Floricultura',
    furniture_store: 'Loja de móveis',
    jewelry_store: 'Joalheria',
    clothing_store: 'Loja de roupas',
    shoe_store: 'Loja de calçados',
    electronics_store: 'Loja de eletrônicos',
    convenience_store: 'Loja de conveniência',
    department_store: 'Loja de departamento',
    car_dealer: 'Concessionária',
    electric_vehicle_charging_station: 'Estação de Recarga de Veículos Elétricos',
    gas_station: 'Posto de Gasolina',
    parking: 'Estacionamento',

    corporate_office: 'Escritório Corporativo',
    farm: 'Fazenda',
    ranch: 'Rancho',

    book_store: 'Livraria',
    home_goods_store: 'Loja de Utilidades Domésticas',
    market: 'Mercado',
    pet_store: 'Pet Shop',

    store: 'Loja',
    supermarket: 'Supermercado',
    warehouse_store: 'Atacado',
    wholesaler: 'Distribuidor',

    accounting: 'Contabilidade',
    atm: 'Caixa Eletrônico',
    bank: 'Banco',
    barber_shop: 'Barbearia',
    beautician: 'Esteticista',
    hair_care: 'Cuidados com o Cabelo',
    laundry: 'Lavanderia',
    auditorium: 'Auditório',
    performing_arts_theater: 'Teatro de Artes Cênicas',
    preschool: 'Pré-escola',
    hospital: 'Hospital',
    medical_lab: 'Laboratório Médico',
    pharmacy: 'Farmácia',
    wellness_center: 'Centro de Bem-estar',
    yoga_studio: 'Estúdio de Yoga',
    bus_stop: 'Ponto de Ônibus',
    light_rail_station: 'Estação de VLT',
    cafe: 'Café',
    cafeteria: 'Cafeteria',
    deli: 'Delicatessen',
    fine_dining_restaurant: 'Restaurante Gourmet',
    food_court: 'Praça de Alimentação',
    restaurant: 'Restaurante',
    swimming_pool: 'Piscina',
  }
  const [selected, setSelected] = useState<string[]>(defaultChecked)
  const [search, setSearch] = useState('')
  const [raio, setRaio] = useState(500)
  const searchEnabled = true
  const link = '#'
  const {setComercios} = mapStore()

  useEffect(() => {
    // onChange?.(selected)
  }, [selected, onchange])

  const slugToLabel = (slug: string) =>
    labelOverrides[slug] || slug.replaceAll('_', ' ').replace(/\b\w/g, (m) => m.toUpperCase())

  const keepType = (t: string) => onlyTypes.length === 0 || onlyTypes.includes(t)

  const hideCat = (c: string) => hideCategories.includes(c)
  const hideItems = (c: string) => hideItens.includes(c)

  const TABLE_A: Record<string, string[]> = useMemo(
    () => ({
      Automotivo: [
        'car_dealer',
        'car_rental',
        'car_repair',
        'car_wash',
        'electric_vehicle_charging_station',
        'gas_station',
        'parking',
        'rest_stop',
      ],
      Negócios: ['corporate_office', 'farm', 'ranch'],
      Shopping: [
        'asian_grocery_store',
        'auto_parts_store',
        'bicycle_store',
        'book_store',
        'butcher_shop',
        'cell_phone_store',
        'clothing_store',
        'convenience_store',
        'department_store',
        'discount_store',
        'electronics_store',
        'food_store',
        'furniture_store',
        'gift_shop',
        'grocery_store',
        'hardware_store',
        'home_goods_store	',
        'home_improvement_store',
        'jewelry_store',
        'liquor_store',
        'market',
        'pet_store',
        'shoe_store',
        'shopping_mall',
        'sporting_goods_store',
        'store',
        'supermarket',
        'warehouse_store',
        'wholesaler',
      ],
      Finaceiro: ['accounting', 'atm', 'bank'],
      Serviços: [
        'astrologer',
        'barber_shop',
        'beautician',
        'beauty_salon',
        'body_art_service',
        'catering_service',
        'cemetery',
        'child_care_agency',
        'consultant',
        'courier_service',
        'electrician',
        'florist',
        'food_delivery',
        'foot_care',
        'funeral_home',
        'hair_care',
        'hair_salon',
        'insurance_agency',
        'laundry',
        'lawyer',
        'locksmith',
        'makeup_artist',
        'moving_company',
        'nail_salon',
        'painter',
        'plumber',
        'psychic',
        'real_estate_agency',
        'roofing_contractor',
        'storage',
        'summer_camp_organizer',
        'tailor',
        'telecommunications_service_provider',
        'tour_agency',
        'tourist_information_center',
        'travel_agency',
        'veterinary_care',
      ],
      Governo: [
        'city_hall',
        'courthouse',
        'embassy',
        'fire_station',
        'government_office',
        'local_government_office',
        'police',
        'post_office',
      ],
      Culture: [
        'art_gallery',
        'art_studio',
        'auditorium',
        'cultural_landmark',
        'historical_place',
        'monument',
        'museum',
        'performing_arts_theater',
        'sculpture',
      ],
      Education: [
        'library',
        'preschool',
        'primary_school',
        'school',
        'secondary_school',
        'university',
      ],
      'Saúde e bem-estar': [
        'chiropractor',
        'dental_clinic',
        'dentist',
        'doctor',
        'drugstore',
        'hospital',
        'massage',
        'medical_lab',
        'pharmacy',
        'physiotherapist',
        'sauna',
        'skin_care_clinic',
        'spa',
        'tanning_studio',
        'wellness_center',
        'yoga_studio',
      ],
      Habitação: [
        'apartment_building',
        'apartment_complex',
        'condominium_complex',
        'housing_complex',
      ],
      Hospedagem: [
        'bed_and_breakfast',
        'budget_japanese_inn',
        'campground',
        'camping_cabin',
        'cottage',
        'extended_stay_hotel',
        'farmstay',
        'guest_house',
        'hostel',
        'hotel',
        'inn',
        'japanese_inn',
        'lodging',
        'mobile_home_park',
        'motel',
        'private_guest_room',
        'resort_hotel',
        'rv_park',
      ],
      'Entertainment and Recreation': [
        'adventure_sports_center',
        'amphitheatre',
        'amusement_center',
        'amusement_park',
        'aquarium',
        'banquet_hall',
        'barbecue_area',
        'botanical_garden',
        'bowling_alley',
        'casino',
        'childrens_camp',
        'comedy_club',
        'community_center',
        'concert_hall',
        'convention_center',
        'cultural_center',
        'cycling_park',
        'dance_hall',
        'dog_park',
        'event_venue',
        'ferris_wheel',
        'garden',
        'hiking_area',
        'historical_landmark',
        'internet_cafe',
        'karaoke',
        'marina',
        'movie_rental',
        'movie_theater',
        'national_park',
        'night_club',
        'observation_deck',
        'off_roading_area',
        'opera_house',
        'park',
        'philharmonic_hall',
        'picnic_ground',
        'planetarium',
        'plaza',
        'roller_coaster',
        'skateboard_park',
        'state_park',
        'tourist_attraction',
        'video_arcade',
        'visitor_center',
        'water_park',
        'wedding_venue',
        'wildlife_park',
        'wildlife_refuge',
        'zoo',
      ],
      Transporte: [
        'airport',
        'airstrip',
        'bus_station',
        'bus_stop',
        'ferry_terminal',
        'heliport',
        'international_airport',
        'light_rail_station',
        'park_and_ride',
        'subway_station',
        'taxi_stand',
        'train_station',
        'transit_depot',
        'transit_station',
        'truck_stop',
      ],
      'Comidas e Bebidas': [
        'acai_shop',
        'afghani_restaurant',
        'african_restaurant',
        'american_restaurant',
        'asian_restaurant',
        'bagel_shop',
        'bakery',
        'bar',
        'bar_and_grill',
        'barbecue_restaurant',
        'brazilian_restaurant',
        'brunch_restaurant',
        'buffet_restaurant',
        'breakfast_restaurant',
        'cafe',
        'cafeteria',
        'candy_store',
        'cat_cafe',
        'chinese_restaurant',
        'chocolate_factory',
        'chocolate_shop',
        'coffee_shop',
        'confectionery',
        'deli',
        'dessert_restaurant',
        'dessert_shop',
        'diner',
        'dog_cafe',
        'donut_shop',
        'fast_food_restaurant',
        'fine_dining_restaurant',
        'food_court',
        'french_restaurant',
        'greek_restaurant',
        'hamburger_restaurant',
        'ice_cream_shop',
        'indian_restaurant',
        'indonesian_restaurant',
        'italian_restaurant',
        'japanese_restaurant',
        'juice_shop',
        'korean_restaurant',
        'lebanese_restaurant',
        'meal_delivery',
        'meal_takeaway',
        'mediterranean_restaurant',
        'mexican_restaurant',
        'middle_eastern_restaurant',
        'pizza_restaurant',
        'pub',
        'ramen_restaurant',
        'restaurant',
        'sandwich_shop',
        'seafood_restaurant',
        'spanish_restaurant',
        'steak_house',
        'sushi_restaurant',
        'tea_house',
        'thai_restaurant',
        'turkish_restaurant',
        'vegan_restaurant',
        'vegetarian_restaurant',
        'vietnamese_restaurant',
        'wine_bar',
      ],
      Esportes: [
        'arena',
        'athletic_field',
        'fishing_charter',
        'fishing_pond',
        'fitness_center',
        'golf_course',
        'gym',
        'ice_skating_rink',
        'playground',
        'ski_resort',
        'sports_activity_location',
        'sports_club',
        'sports_coaching',
        'sports_complex',
        'stadium',
        'swimming_pool',
      ],
    }),
    []
  )

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase()
    const out: [string, string[]][] = []

    Object.entries(TABLE_A).forEach(([cat, types]) => {
      if (hideCat(cat)) return
      const items = types
        .filter((t) => keepType(t))
        .filter((t) => {
          const hide = !hideItems(t)
          if (!hideItems(t)) {
            // console.log(t)
          }
          return hide
        })
        .filter((t) => (q ? slugToLabel(t).toLowerCase().includes(q) || t.includes(q) : true))
      //   console.log('items')

      if (items.length) out.push([cat, items])
    })

    return out
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TABLE_A, search, onlyTypes, hideCategories, labelOverrides])

  const toggle = (t: string) => {
    setSelected((prev) => (prev.includes(t) ? prev.filter((x) => x !== t) : [...prev, t]))
  }

  async function load() {
    console.log('lat', lat)
    console.log('lng', lng)

    // const marquerLayer = Explorer.addMarker(lat, lng, 'Comércios', 'Comércios')
    // console.log('marquerLayer')
    // console.log(marquerLayer)
    // Explorer.setDrawMode('marker')
    const comercios = await getComercios({
      latitude: lat,
      longitude: lng,
      raio: raio,
      maxResult: 20,
      types: selected,
    })
    console.log({
      list: comercios.places,
      center: {lat: lat, lng: lng},
      raio: raio,
      layerParent: '',
    })

    setComercios({
      list: comercios.places,
      center: {lat: lat, lng: lng},
      raio: raio,
      layerParent: '',
    })
    closeModal()
    Layout.setShowContextMenu(false, null)
    // setComercios({list: comercios.places, center: {lat: lat, lng: lng}, raio: raio})
  }

  function closeModal() {
    setShow(false)
  }

  // <a href={link} className='context-event' onClick={load}>
  const ref = '#'
  // </a>
  return (
    <>
      <a
        href={ref}
        type='button'
        className='context-event'
        onClick={() => {
          setShow(true)
        }}
      >
        Carregar comércios
      </a>
      <Modal centered animation show={show} onHide={() => closeModal()} size={'xl'}>
        <Modal.Header closeButton>
          <Modal.Title>Selecionar Categorias de Comérios</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{marginBottom: '1rem'}}
            className='d-flex gap-2 align-items-center flex-wrap justify-content-between'
          >
            <div className='d-flex gap-2 align-items-center flex-wrap flex-fill'>
              {searchEnabled && (
                <input
                  type='search'
                  className='form-control'
                  placeholder='Filtrar por nome (ex.: padaria, cafeteria, hospital)'
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{maxWidth: 420}}
                />
              )}
              <span className='badge text-bg-light'>Selecionados: {selected.length}</span>
            </div>
            <div className='d-flex align-items-center   gap-2 '>
              <label className='form-label fs-5'>Raio(metros):</label>
              <input
                type='number'
                value={raio}
                onChange={(e) => setRaio(Number(e.target.value))}
                className='form-control'
              />
            </div>
          </div>

          {filtered.map(([cat, types]) => (
            <section key={cat} style={{marginBottom: '1.5rem'}}>
              <h2 style={{fontSize: '1.05rem'}} className='ms-0 mb-5'>
                {cat}
              </h2>
              <div
                className='types-grid ms-5'
                style={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${columns}, minmax(0,1fr))`,
                  gap: '.75rem',
                }}
              >
                {types.map((t) => {
                  const id = `type_${t}`
                  const checked = selected.includes(t)
                  return (
                    <div
                      key={t}
                      className='form-check form-switch'
                      style={{
                        minHeight: '2rem',
                        paddingLeft: '3rem',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <input
                        className='form-check-input'
                        type='checkbox'
                        id={id}
                        name='types[]'
                        value={t}
                        checked={checked}
                        onChange={() => toggle(t)}
                      />
                      <label className='form-check-label ms-2' htmlFor={id}>
                        {slugToLabel(t)}
                      </label>
                    </div>
                  )
                })}
              </div>
            </section>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn btn-primary' onClick={load}>
            Buscar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default LoadComercios
